import numeral from 'numeral';

interface ICalculatePriceDifferenceParams {
  openPrice: number;
  currentPrice: number;
}

interface ICalculatePriceDifferenceResult {
  priceGained: boolean;
  priceDifference: number;
  percentageDifference: number;
}

export const calculatePriceDifference = (params: ICalculatePriceDifferenceParams): ICalculatePriceDifferenceResult => {
  const { openPrice, currentPrice } = params;

  const priceDifference = numeral(currentPrice).subtract(openPrice).value() || 0;
  const percentageDifference = (priceDifference / openPrice) * 100;
  const priceGained = priceDifference >= 0 && percentageDifference >= 0;

  return {
    priceGained,
    priceDifference,
    percentageDifference
  };
};
